import React from 'react'
import Griddle, {plugins, RowDefinition, ColumnDefinition} from 'griddle-react'
import {Context} from '../../context'
import components from './columns'

import './rollbook.styl'

const {columns, headers} = components

const Layout = ({Table, Pagination, Filter}) => (
  <div className="rollbook-table">
    <Table />
  </div>
)

export default class Rollbook extends React.Component {
  static contextType = Context

  constructor(props) {
    super(props)
  }

  render () {
    const context = this.context 
    const {groups} = context
    return (
        <div className="wrapper">
          <Griddle
            data={groups}
            components={{
              Layout
            }}
          >
           <RowDefinition>
             <ColumnDefinition
               id='name'
               customHeadingComponent={headers.RollbookHeader}
             />
             <ColumnDefinition
               id='subject'
               customHeadingComponent={headers.RollbookHeader}
               customComponent={columns.SubjectColumn}
             />
             <ColumnDefinition
               id='links'
               customHeadingComponent={headers.EmptyHeader}
               customComponent={columns.RollbookLinksColumn}
             />
           </RowDefinition>
          </Griddle>
      </div>
    )
  }
}
